import React from "react";
import { useTitle } from "../../common/utils/title";

const LeadList: React.FC = () => {
  useTitle("Leads");
  return <></>;
};

export default LeadList;
